import {
  InnerContentItem,
  OuterContentItem,
  PrimaryTag,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

import { getAddressDate, getAddressWithUnit } from "./utils";
import { useCountryName } from "../../../../components/AddressInput";

export function AddressSummaryField({
  field,
}: {
  field: components["schemas"]["AddressesCheckField"];
}) {
  const { t } = useTranslation();
  const getCountryName = useCountryName();

  return (
    <>
      {field.value
        .sort((a) => (a.end_date ? 1 : -1))
        .map((address, index) => (
          <OuterContentItem
            key={address.id}
            title={getAddressWithUnit(address)}
            subtitle={getAddressDate(address)}
            tag={
              !address.end_date && (
                <PrimaryTag type="subtle">
                  <Trans>Current</Trans>
                </PrimaryTag>
              )
            }
            testID={`address-summary-address-${index + 1}`}
          >
            <InnerContentItem
              label={t("Address")}
              testID={`address-summary-address-${index + 1}`}
            >
              {getAddressWithUnit(address)}
              <br />
              {address.city} {address.province_state},{" "}
              {getCountryName(address.country) ?? address.country}
              <br />
              {address.postal_code}
            </InnerContentItem>

            <InnerContentItem
              label={t("Start date")}
              testID={`address-summary-start-date-${index + 1}`}
            >
              {formatDate(address.start_date, "MMMM yyyy")}
            </InnerContentItem>
            {address.end_date && (
              <InnerContentItem
                label={t("End date")}
                testID={`address-summary-end-date-${index + 1}`}
              >
                {formatDate(address.end_date, "MMMM yyyy")}
              </InnerContentItem>
            )}
          </OuterContentItem>
        ))}
    </>
  );
}
